import './PopUpMenu.style.less'

import { Button, Dropdown, Menu, Popover, Row } from 'antd'
import { DeleteOutlined, EditOutlined, MoreOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
interface Props {
  onEdit: () => void
  onDelete?: () => void
  removeTitle?: string
}

function PopUpMenu({ onEdit, onDelete, removeTitle }: Props) {
  const { t } = useTranslation()
  const [popover, setPopover] = useState(false)

  const content = (
    <div className="content-popmenu-delete">
      {removeTitle ? (
        <p>{removeTitle}</p>
      ) : (
        <p>Do you want to delete this item?</p>
      )}

      <Row justify={'center'}>
        <Button onClick={() => setPopover(false)}>No</Button>
        <Button
          onClick={() => {
            onDelete()
            setPopover(false)
          }}
          type="primary"
        >
          Yes
        </Button>
      </Row>
    </div>
  )

  return (
    <Dropdown
      trigger={['click']}
      overlay={
        <Menu>
          <Menu.Item key="1" className="menuButton">
            <Button onClick={onEdit} size="large">
              <EditOutlined />
              {t('pbf.option.edit')}
            </Button>
          </Menu.Item>

          {onDelete && (
            <Menu.Item key="2" className="menuButton">
              <Popover
                open={popover}
                content={content}
                onOpenChange={() => setPopover(true)}
                trigger={'click'}
              >
                <Button size="large">
                  <DeleteOutlined />
                  Delete
                </Button>
              </Popover>
            </Menu.Item>
          )}
        </Menu>
      }
    >
      <Button className="button-system-config-action">
        <MoreOutlined />
      </Button>
    </Dropdown>
  )
}

export default PopUpMenu
